import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const CONSENT_KEY = "incolour_analytics_consent";

export default function AnalyticsConsent() {
  const location = useLocation();
  const [choice, setChoice] = useState(() => localStorage.getItem(CONSENT_KEY));

  useEffect(() => {
    if (choice === "accepted" && window.enableIncolourAnalytics) {
      window["ga-disable-G-MTJHMCKW1T"] = false;
      window.enableIncolourAnalytics();
    }
  }, [choice]);

  useEffect(() => {
    const reopen = () => setChoice(null);
    window.addEventListener("incolour:analytics-settings", reopen);
    return () => window.removeEventListener("incolour:analytics-settings", reopen);
  }, []);

  if (location.pathname.startsWith("/admin") || choice) return null;

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setChoice("accepted");
  };

  const decline = () => {
    window["ga-disable-G-MTJHMCKW1T"] = true;
    localStorage.setItem(CONSENT_KEY, "declined");
    setChoice("declined");
  };

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[90] border-t border-cream/10 bg-ink/95 px-4 py-4 text-cream shadow-2xl backdrop-blur-xl sm:px-6"
      role="dialog"
      aria-label="Analytics preference"
      data-testid="analytics-consent"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="max-w-3xl text-sm leading-relaxed text-cream/75">
          We use optional analytics to understand how visitors use our website.
          You can decline and the site will still work normally.{" "}
          <Link to="/privacy" className="font-semibold text-cream underline underline-offset-4">
            Privacy
          </Link>
        </p>

        <div className="flex shrink-0 gap-3">
          <button
            type="button"
            onClick={decline}
            className="rounded-full border border-cream/25 px-5 py-2.5 text-sm font-semibold text-cream transition-colors hover:border-cream/60"
            data-testid="analytics-decline"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={accept}
            className="rounded-full bg-orange px-5 py-2.5 text-sm font-semibold text-cream transition-transform hover:scale-[1.03]"
            data-testid="analytics-accept"
          >
            Accept analytics
          </button>
        </div>
      </div>
    </div>
  );
}
